"use strict";

exports.__esModule = true;
exports.default = void 0;

var _formFile = require("./form-file");

var _plugins = require("../../utils/plugins");

var components = {
  BFormFile: _formFile.default,
  BFile: _formFile.default
};
var _default = {
  install: function install(Vue) {
    (0, _plugins.registerComponents)(Vue, components);
  }
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/form-file/index.js
// module id = 1192
// module chunks = 0